import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Tooltip from '../../components/common/Tooltip';
import ErrorModal from '../../containers/common/ErrorModal';
import StyledTappable from '../common/StyledTappable';
import { RegularText, BoldText } from '../common/Text';
import { FaTimes } from 'react-icons/fa';

import arrowRight from '../../images/common/arrow-right.svg';
import ellipseIcon from '../../images/common/ellipse.svg';
import tickIcon from '../../images/common/tick.svg';
import cautionIcon from '../../images/common/caution.svg';
import clockIcon from '../../images/lab-test/green-clock.svg';
import PathologyIcon from '../../images/lab-test/pathology.svg';
import PathologyGreenIcon from '../../images/lab-test/microscope-green.svg';
import RadiologyIcon from '../../images/lab-test/radiology.svg';
import cartIcon from '../../images/lab-test/cart-new.svg';
import crossIcon from '../../images/lab-test/cross.svg';
import orderPlacedIcon from '../../images/lab-test/order-placed.svg';
import patientIcon from '../../images/lab-test/patient-icon.svg';
import calendarIcon from '../../images/lab-test/order-calendar.svg';
import partnerIcon from '../../images/lab-test/partner.svg';
import partnerNameIcon from '../../images/lab-test/partner-name.svg';
import completedIcon from '../../images/lab-test/completed.svg';
import completedEarlyIcon from '../../images/lab-test/completed-early.svg';
import partnerConfirmIcon from '../../images/lab-test/partner-icon.svg';
import sampleProcessingIcon from '../../images/lab-test/sample-processing.svg';
import prescriptionIcon from '../../images/lab-test/precription-card-icon.svg';
import samplePickUpIcon from '../../images/lab-test/sample-pickup.svg';
import profileIcon from '../../images/common/profile.svg';
import stethoscope from '../../images/pharmacy/stethoscope.png';
import arrowRightFill from '../../images/lab-test/arrowright-fill.svg';
import crossFillIcon from '../../images/lab-test/cross-fill.svg';
import newCrossIcon from '../../images/lab-test/new-cross.svg';
import SyringeIcon from '../../images/lab-test/syringe.svg';
import oldTimeIcon from '../../images/lab-test/old-time.svg';
import newTimeIcon from '../../images/lab-test/new-time.svg';
import oldPartnerIcon from '../../images/lab-test/old-partner.svg';
import copayIcon from '../../images/lab-test/copay.svg';
import copayWalletIcon from '../../images/lab-test/copay-wallet.svg';
import modalIcon from '../../images/lab-test/emergency-tick.svg';
import CIIcon from '../../images/pharmacy/ci-icon.svg';
//import ConfirmedIcon from '../../images/pharmacy/confirmed-icon.svg';
import ConfirmedIcon from '../../images/pharmacy/new-confirmed-icon.svg';
import CoPayIcon from '../../images/pharmacy/co-pay-icon.svg';
import DrugIcon from '../../images/pharmacy/drug-icon.svg';
import DeliveredIcon from '../../images/pharmacy/delivered-icon.svg';
import DateIcon from '../../images/pharmacy/date-icon.svg';
import OrderDeliveredIcon from '../../images/pharmacy/order-delivered-icon.svg';
import {
  intitiateEmergencyCall,
  payLabCopay,
  postSamplePickup,
} from '../../services';
import initializeFreshDesk from '../../utils/freshchat';
import { openIFrame } from '../../actions';
import { ReactComponent as HomeDeliveryIcon } from '../../images/pharmacy/home-delivery-icon.svg';
import { ReactComponent as StorePickupIcon } from '../../images/pharmacy/store-pickup-icon.svg';
import AddressIcon from '../../images/pharmacy/address-icon.svg';
import DirectionIcon from '../../images/pharmacy/direction-icon.svg';
import { logEvent } from '../../utils/logEvent';
import CardImage from '../../images/pharmacy/card';

const ScreenIcon = styled.img`
  filter: ${(props) =>
    props.type === 'digitisationDelayed' ||
    props.type === 'digitisationRejected' ||
    props.type === 'delayed'
      ? 'brightness(0) saturate(100%) invert(54%) sepia(42%) saturate(985%) hue-rotate(324deg) brightness(102%) contrast(100%)'
      : 'none'};
`;
const EllipseIcon = styled.img`
  filter: ${(props) =>
    props.type === 'digitisationDelayed' ||
    props.type === 'digitisationRejected' ||
    props.type === 'Delayed'
      ? 'brightness(0) saturate(100%) invert(54%) sepia(42%) saturate(985%) hue-rotate(324deg) brightness(102%) contrast(100%)'
      : 'none'};
`;

const IconContainer = styled.div`
  align-self: start;
  border: 1px solid
    ${(props) =>
      props.type === 'digitisationRejected' ? '#FF754C' : '#E3E3E3'};
  border-radius: 12px;
  margin-right: 12px;
  text-align: center;
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalContainer = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  z-index: 0;
`;

const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: white;
  max-width: 400px;
  padding: 1.125rem 1.25rem 1.875rem 1.25rem;
  border-radius: 0.5rem;
  margin: 0 1rem;
  text-align: center;
  z-index: 3;
`;
const CloseContainer = styled.div`
  cursor: pointer;
  align-self: flex-end;
`;

const ModalIcon = styled.img`
  width: 78px;
  height: 78px;
`;

const ModalText = styled(RegularText)`
  font-size: ${() => `${1 * process.env.REACT_APP_FONT_MULTIPLIER}rem`};
  margin: 0.625rem 0rem;
  color: #0f0b28;
  font-weight: 500;
`;

const providerLogoContainerStyles = {
  display: 'flex',
  // alignItems: 'center',
  // width: 'max-content',
  justifyContent: 'flex-end',
  gap: '5px',
  alignItems: 'center',
  // position:'relative'
};

const providerLogoStyles = {
  width: '38px',
  height: '38px',
  borderRadius: '50%',
  border: '2px solid rgb(228 228 228 / 66%)',
  position: 'relative',
};

const PrescriptionStatusCard = ({ orderRequest, onTap, history, key }) => {
  let {
    cardType: type,
    digitisationId,
    prescribedTime,
    status,
    orderStatus,
  } = orderRequest;
  const authToken = useSelector((state) => state.user.authToken);
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [modalDetails, setModalDetails] = useState({
    showModal: false,
    modalText: '',
  });
  const [showTooltip, setShowTooltip] = useState(false);
  const [ciToolTip, setCiToolTip] = useState(false);

  const emergencyCallHandler = (e) => {
    e.stopPropagation();

    if (!orderRequest.orderId && orderRequest.isDelayed) {
      initializeFreshDesk(user);
    } else {
      const orderId = orderRequest.orderId;
      intitiateEmergencyCall(authToken, orderId)
        .then((res) => {
          console.log(res);
          setModalDetails({ showModal: true, modalText: res });
        })
        .catch((err) => {});
    }
  };
  const hideModal = (e) => {
    e.stopPropagation();
    setModalDetails({ showModal: false, modalText: '' });
  };
  const openSupport = (e) => {
    e.stopPropagation();
    dispatch(
      openIFrame(`${user.ticketingUrl}?token=${user.authToken.split(' ')[1]}`)
    );
  };

  if (orderRequest.orderStatus === 'confirmed' && orderRequest.amount) {
    type = 'order';
    orderRequest.orderStatus = 'mix-credit';
  }

  if (
    type === 'digitisationDelayed' ||
    type === 'transcribing' ||
    type === 'digitisationRejected'
  ) {
    return (
      <div
        className="hover pt-16px mt-16px rounded-12"
        style={{
          border: `1px solid ${
            status !== 'Delayed' && status !== 'Rejected'
              ? '#E6E9EC'
              : '#FF754C'
          }`,
        }}
        onClick={onTap}
      >
        <div
          className="flex flex-row justify-between items-center px-16px pb-10px"
          style={{
            borderBottom: `${
              type === 'transcribing' ? 'none' : '1px solid #F0F3F6'
            }`,
          }}
        >
          <div className="flex justify-between w-full items-start">
            <div className="flex">
              <IconContainer color={type}>
                <img
                  src={prescriptionIcon}
                  alt="prescription"
                  style={{ minWidth: '17.37px', minHeight: '26.12px' }}
                />
              </IconContainer>
              <div className="flex flex-col">
                <span className="text-title-s font-semibold text-txtlight">
                  {orderRequest.title}
                </span>
                <div
                  className="text-chip font-medium mt-2px"
                  style={{
                    color: `${status === 'Rejected' ? '#0F0B28' : '#767787'}`,
                  }}
                >
                  {status === 'Rejected' ? null : orderRequest.text}
                  {status === 'Rejected' && orderRequest.invalid_reason && (
                    <p className="text-txtlight font-semibold">
                      Reason: {orderRequest.invalid_reason}
                    </p>
                  )}
                </div>
              </div>
            </div>
            <img className="float-right" src={arrowRight} alt="right" />
          </div>
          {/* <ScreenIcon
            className="float-right self-start"
            src={arrowRight}
            alt="right"
            type={type}
          /> */}
        </div>
        <div
          className="flex flex-row items-center justify-between pb-12px px-16px border-t pt-12px border-txtsecondary-shades4"
          style={{
            marginTop: `${type === 'transcribing' ? '6px' : '12px'}`,
            borderBottom: `${
              type === 'transcribing' ? 'none' : '1px solid #F0F3F6'
            }`,
          }}
        >
          {orderRequest.status !== 'Uploaded' && (
            <div className="flex items-start">
              <img src={clockIcon} alt="prescribed-time" />
              <div className="flex flex-col  ml-8px">
                <p className=" text-card-body">
                  Request Id: {orderRequest.digitisationId}
                </p>
              </div>
            </div>
          )}
          {orderRequest.status === 'Uploaded' && (
            <div className="flex items-start">
              <img src={clockIcon} alt="prescribed-time" />
              <div className="flex flex-col  ml-8px">
                <p className="text-body-s">
                  Digitization Id: {orderRequest.digitisationId}
                </p>
                <p className="text-sub text-card-body">
                  {orderRequest.prescribedTime}
                </p>
              </div>
            </div>
          )}
          <div className="flex flex-row items-center">
            {status === 'Rejected' ? (
              <img src={crossIcon} alt="cross" />
            ) : (
              <div>
                <EllipseIcon
                  src={ellipseIcon}
                  alt="ellipse"
                  height={11}
                  width={12}
                  className="icon-spin"
                  type={status}
                />
              </div>
            )}

            <span
              className="text-body-s font-medium ml-4px"
              style={{
                color: `${status !== 'Uploaded' ? '#FF754C' : '#ffbb00'}`,
              }}
            >
              {status === 'Uploaded' && 'Digitizing'}
              {status === 'Delayed' && 'Delayed'}
              {status === 'Rejected' && 'Rejected'}
            </span>
          </div>
        </div>
        {status === 'Delayed' && (
          <button
            className="flex justify-center w-full text-center py-12px text-body-s text-black font-semibold tracking-wide border-t border-txtlight-shades4"
            onClick={openSupport}
          >
            Contact Support
          </button>
        )}

        {status === 'Rejected' && (
          <button
            className="flex justify-center w-full text-center py-12px text-body-s text-black font-semibold tracking-wide border-t border-txtlight-shades4"
            onClick={(e) => {
              e.stopPropagation();
              history.push('/pharmacy/upload-prescription');
            }}
          >
            Re-upload Prescription
          </button>
        )}
        {modalDetails.showModal && (
          <ErrorModal>
            <ModalContainer onClick={hideModal}>
              <ModalBody onClick={(e) => e.stopPropagation()}>
                <CloseContainer onClick={(e) => hideModal(e)}>
                  <FaTimes />
                </CloseContainer>
                <ModalIcon
                  onClick={(e) => e.stopPropagation()}
                  src={modalIcon}
                />
                <ModalText onClick={(e) => e.stopPropagation()}>
                  {modalDetails.modalText}
                </ModalText>
              </ModalBody>
            </ModalContainer>
          </ErrorModal>
        )}
      </div>
    );
  } else if (type === 'transcribed') {
    return (
      <div
        className="hover pt-16px mt-16px rounded-12"
        style={{
          border: `1px solid ${'#E6E9EC'}`,
        }}
        onClick={onTap}
      >
        <div
          className="flex flex-row justify-between items-center px-16px pb-16px"
          style={{
            borderBottom: `${'1px solid #F0F3F6'}`,
          }}
        >
          <div className="flex">
            <IconContainer color={type}>
              <img
                src={orderPlacedIcon}
                alt="order-placed"
                style={{ minWidth: '19.71px', minHeight: '19.71px' }}
              />
            </IconContainer>
            <div className="flex flex-col justify-center">
              <span className="text-title-s font-semibold text-txtlight">
                {orderRequest.title}
              </span>
              <div className="text-card-body font-medium mt-2px text-sub">
                {orderRequest.text}
              </div>
            </div>
          </div>
          <ScreenIcon
            className="float-right self-start"
            src={arrowRight}
            alt="right"
            type={type}
          />
        </div>
        <div
          className="flex flex-row items-end justify-between pb-12px px-16px"
          style={{
            marginTop: `${type === 'transcribing' ? '6px' : '12px'}`,
            borderBottom: `${
              type === 'transcribing' ? 'none' : '1px solid #F0F3F6'
            }`,
          }}
        >
          <div className="flex flex-col">
            <div className="flex items-start">
              <img src={patientIcon}></img>
              <div className="flex flex-col  ml-8px">
                <p className="text-body-s text-txtlight font-medium">Patient</p>
                <p className="text-sub text-card-body">
                  {orderRequest.patientName}
                </p>
              </div>
            </div>
          </div>
          {/* <div className="flex flex-row items-center">
            {type === 'digitisationRejected' ? (
              <img src={crossIcon} alt="cross" />
            ) : (
              <EllipseIcon
                src={ellipseIcon}
                alt="ellipse"
                height={11}
                width={12}
                className="icon-spin"
                type={type}
              />
            )}

            <span
              className="text-body-s font-medium ml-4px"
              style={{
                color: `${type !== 'transcribing' ? '#FF754C' : '#3F8CFF'}`,
              }}
            >
              {type === 'transcribing' && 'Digitizing'}
              {type === 'digitisationDelayed' && 'Delayed'}
              {type === 'digitisationRejected' && 'Rejected'}
            </span>
          </div> */}
        </div>
        {orderRequest.showEmergencyButtonCall && (
          <div
            className="text-center py-12px text-body-s text-primary font-semibold tracking-wide"
            onClick={openSupport}
          >
            {type === 'digitisationDelayed'
              ? 'Contact Support'
              : 'Request Callback'}
          </div>
        )}
        {orderRequest.resubmit && (
          <button
            className="text-center py-12px text-body-s text-primary font-semibold"
            onClick={() => history.push('/pharmacy/upload-prescription')}
          >
            Re-upload Prescription
          </button>
        )}
        {modalDetails.showModal && (
          <ErrorModal>
            <ModalContainer onClick={hideModal}>
              <ModalBody onClick={(e) => e.stopPropagation()}>
                <CloseContainer onClick={(e) => hideModal(e)}>
                  <FaTimes />
                </CloseContainer>
                <ModalIcon
                  onClick={(e) => e.stopPropagation()}
                  src={modalIcon}
                />
                <ModalText onClick={(e) => e.stopPropagation()}>
                  {modalDetails.modalText}
                </ModalText>
              </ModalBody>
            </ModalContainer>
          </ErrorModal>
        )}
      </div>
    );
  } else if (type === 'reimbursement') {
    return (
      <div
        className="hover p-16px pb-12px mt-16px border border-txtsecondary-shades7 border-solid rounded-12"
        onClick={onTap}
      >
        <div className="flex flex-row justify-between	items-center pb-4px">
          <span className="text-title-s font-semibold">Reimbursement</span>
          <img className="float-right" src={arrowRight} alt="right" />
        </div>
        <div>
          <p className="lab-test-name mt-13">{orderRequest.patientName}</p>
          <p className="txt-grey-600-12 mt-4 mb-4">
            {orderRequest.prescriptionGivenOn}
          </p>

          <p className="txt-black-600-12 lab-home-btn hover" onClick={onTap}>
            {orderRequest.btnLabel}
          </p>
        </div>
      </div>
    );
  } else if (type === 'booked-order') {
    return (
      <div
        className="p-16px pt-0 pb-12px mt-16px border border-txtsecondary-shades7 border-solid	rounded-12"
        onClick={() => {
          onTap(orderRequest);
        }}
      >
        <span
          className="py-4px px-12px text-secondary-shades2 text-body-s font-semibold"
          style={{
            background: 'rgba(207, 200, 255, 0.2)',
            borderRadius: '0px 0px 8px 8px',
          }}
        >
          {orderRequest.testsTypeName}
        </span>
        <div className="flex flex-row justify-between pt-12px items-center pb-4px">
          <div className="flex flex-row items-center">
            {orderRequest.status === 'pending' ||
            orderRequest.status === 'completed' ? (
              <img src={tickIcon} alt="tick" height={11} width={12} />
            ) : (
              <img src={cautionIcon} alt="tick" height={11} width={12} />
            )}
            <div
              className="text-body-s font-semibold pl-8px"
              style={
                orderRequest.status === 'pending' ||
                orderRequest.status === 'completed'
                  ? { color: '#3F8CFF' }
                  : { color: '#FF754C' }
              }
            >
              {orderRequest.status === 'payment-pending'
                ? orderRequest.pendingCopayText || orderRequest.status
                : orderRequest.status}
            </div>
          </div>
        </div>
        <div className="text-title-s font-semibold">
          {orderRequest.testNames}
        </div>
        {orderRequest.doctorName && (
          <div className="flex flex-row items-center pb-2px">
            <img src={stethoscope} alt="stethoscope" height={12} width={12} />
            <div className="text-body-s text-txtsecondary font-medium pl-4px ">
              {orderRequest.doctorName}
            </div>
          </div>
        )}
        <div className="flex flex-row items-center pb-24px">
          <img src={profileIcon} alt="profile" height={12} width={12} />
          <div className="text-body-s text-txtsecondary font-medium pl-4px ">
            {orderRequest.patientName}
          </div>
        </div>
        <div className="flex flex-row justify-between items-center">
          <div className="text-chip text-txtsecondary">
            {orderRequest.bookedOn}
          </div>
          <div className="flex flex-row hover">
            <p className="text-body-l text-primary font-semibold mr-8px">
              {orderRequest.status === 'payment-pending'
                ? 'Pay & Confirm'
                : 'View Details'}
            </p>
            <img src={arrowRightFill} />
          </div>
        </div>
      </div>
    );
  } else if (type === 'availableCart') {
    return (
      //   <div className="p-16px pt-0 pb-12px mt-16px border border-txtsecondary-shades7 border-solid	rounded-12">
      //     <div className="flex flex-row items-center mt-16px">
      //       <img src={tickIcon} alt="tick" height={11} width={12} />
      //       <p className="text-body-s font-semibold text-secondary-shades6 ml-4px">
      //         Transcribed
      //       </p>
      //     </div>
      //     <div className="text-body-l font-semibold text-txtlight pt-4px pb-4px">
      //       Tests Ready for order
      //     </div>
      //     <div className="text-title-s font-semibold">
      //       {orderRequest.testNames}
      //     </div>
      //     {orderRequest.doctorName && (
      //       <div className="flex flex-row items-center pb-2px">
      //         <img src={stethoscope} alt="stethoscope" height={12} width={12} />
      //         <div className="text-body-s text-txtsecondary font-medium pl-4px ">
      //           {orderRequest.doctorName}
      //         </div>
      //       </div>
      //     )}
      //     <div className="flex flex-row items-center pb-24px">
      //       <img src={profileIcon} alt="profile" height={12} width={12} />
      //       <div className="text-body-s text-txtsecondary font-medium pl-4px ">
      //         {orderRequest.patientName}
      //       </div>
      //     </div>
      //     <div>
      //       <div className="text-chip text-txtsecondary">
      //         {orderRequest.prescriptionGivenOn}
      //       </div>
      //       <div
      //         className="bg-primary hover rounded-12 max-w-100 mt-8px py-10px text-center"
      //         onClick={() => {
      //           onTap(orderRequest);
      //         }}
      //       >
      //         <p className="text-body-l text-textbox font-semibold">
      //           View & Confirm
      //         </p>
      //       </div>
      //     </div>
      //   </div>
      <div
        className="hover pt-16px mt-16px rounded-12 border border-solid border-boxCard"
        onClick={onTap}
      >
        <div className="flex flex-row justify-between items-center px-16px pb-20px border-b border-solid border-txtsecondary-shades4">
          <div className="flex">
            <IconContainer color={type} style={{ padding: '10px 9px' }}>
              <img
                src={cartIcon}
                alt="cart"
                style={{ minWidth: '23px', minHeight: '19px' }}
              />
            </IconContainer>
            <div className="flex flex-col">
              <span className="text-title-s font-semibold text-txtlight">
                {orderRequest.title}
              </span>
              <div className="text-chip font-medium mt-2px text-sub">
                {orderRequest.infoText}
              </div>
            </div>
          </div>
          <img
            className="float-right self-start"
            src={arrowRight}
            alt="right"
            type={type}
          />
        </div>
        <div
          className="flex flex-col items-start pb-12px px-16px"
          style={{
            marginTop: `${type === 'transcribing' ? '6px' : '12px'}`,
            borderBottom: '1px solid #F0F3F6',
          }}
        >
          <div className="flex flex-row">
            {!orderRequest.digitisationId ? (
              <>
                <img
                  src={stethoscope}
                  alt="prescribed-time"
                  width={'16px'}
                  height={'16px'}
                />
                <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                  {orderRequest.consultationStr}
                </p>
              </>
            ) : (
              <>
                <img src={clockIcon} alt="prescribed-time" />
                <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                  Request ID - {orderRequest.digitisationId}
                </p>
              </>
            )}
          </div>
          <div className="flex flex-row items-center mt-8px">
            {orderRequest.testsType === 'pathology' && (
              <img src={PathologyIcon} alt="test type" className="self-start" />
            )}
            {orderRequest.testsType === 'radiology' && (
              <img src={RadiologyIcon} alt="test type" className="self-start" />
            )}
            <div className="flex flex-col">
              <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                Tests Booked - {orderRequest.testsTypeName}
              </p>
              <p className="text-chip text-txtsecondary-shades8 ml-8px">
                {orderRequest.testNames}
              </p>
            </div>
          </div>
        </div>
        <div
          className="text-center py-12px text-body-s text-primary font-semibold tracking-wide"
          onClick={() => {
            history.push('/pharmacy/order-status', {
              cartId: orderRequest.cartId,
              digitizationId: orderRequest.digitizationId,
              bookedOnDate: orderRequest.bookedOnDate ?? null,
            });
          }}
        >
          Place Order
        </div>
      </div>
    );
  } else if (type === 'order') {
    const mainIcon = () => {
      if (orderRequest.orderStatus === 'confirmed')
        return <img src={ConfirmedIcon}></img>;
      else if (orderRequest.orderStatus === 'select-partner')
        return <img src={ConfirmedIcon}></img>;
      else if (orderRequest.orderStatus === 'cart-created')
        return (
          <img
            src={partnerConfirmIcon}
            alt="cart-created"
            style={{ minWidth: '18px', minHeight: '18px' }}
          />
        );
      else if (orderRequest.orderStatus === 'mix-credit')
        return <img src={CoPayIcon}></img>;
      else if (orderRequest.orderStatus === 'cancelled')
        return (
          <img
            src={newCrossIcon}
            alt="cancelled"
            style={{ minWidth: '18px', minHeight: '18px' }}
          />
        );
      else if (orderRequest.orderStatus === 'delivered')
        return (
          <img
            style={{ minWidth: '18px', minHeight: '18px' }}
            src={OrderDeliveredIcon}
          ></img>
        );
      else
        return (
          <img
            src={orderPlacedIcon}
            alt="order-placed"
            style={{ minWidth: '18px', minHeight: '18px' }}
          />
        );
    };
    return (
      <div
        className="hover pt-16px mt-16px rounded-12 border border-solid border-boxCard"
        onClick={onTap}
        style={{
          borderColor: orderRequest.status === 'Delayed' ? '#FF754C' : '',
          paddingTop: orderRequest.orderDeliveryType ? '0' : '',
        }}
      >
        {orderRequest.orderDeliveryType && (
          <div className="px-20px pb-12px w-full flex">
            <div className="flex p-12px bg-primary-light w-auto items-center py-6px rounded-b-12">
              {orderRequest.orderDeliveryType === 'home-delivery' ? (
                <HomeDeliveryIcon fill="#ffbb00"></HomeDeliveryIcon>
              ) : (
                <StorePickupIcon fill="#ffbb00"></StorePickupIcon>
              )}

              <p className="ml-8px text-primary text-body-s font-semibold">
                {orderRequest.orderDeliveryType === 'home-delivery'
                  ? 'Home Delivery'
                  : 'Store Pickup'}
              </p>
            </div>
          </div>
        )}
        <div className="flex flex-row justify-between items-center px-16px pb-20px border-b border-solid border-txtsecondary-shades4">
          <div className="flex">
            <IconContainer color={type}>{mainIcon()}</IconContainer>
            <div className="flex flex-col">
              <span className="text-title-s font-semibold text-txtlight">
                {orderRequest.headingText}
              </span>
              <div className="text-body-s font-medium mt-2px text-sub w-64">
                {orderRequest.text}
              </div>
            </div>
          </div>
          <img
            className="float-right self-start"
            src={arrowRight}
            alt="right"
            type={type}
          />
        </div>
        <div
          className="flex flex-col items-start pb-12px px-16px"
          style={{
            marginTop: '12px',
            borderBottom: '1px solid #F0F3F6',
          }}
        >
          {orderRequest.orderId && (
            <div className="flex items-start">
              <img src={clockIcon} alt="prescribed-time" />
              <div className="flex flex-col ml-8px">
                <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                  Order ID - {orderRequest.orderId}
                </p>
                {orderRequest.createdAt && (
                  <p className="text-card-body text-sub">
                    Booked on - {orderRequest.createdAt}
                  </p>
                )}
              </div>
            </div>
          )}
          {orderRequest.drugName && (
            <div className="flex w-full flex-row items-start mt-8px">
              <img src={DrugIcon}></img>
              <div className="flex w-full justify-between items-center">
                <div className="flex-col">
                  <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                    Prescribed Medicines
                  </p>
                  <p className="text-chip text-txtsecondary-shades8 ml-8px">
                    {orderRequest.drugName}
                  </p>
                </div>
                {orderRequest.criticalOrder && (
                  <div className="relative">
                    {ciToolTip && (
                      <div
                        className="absolute p-4px px-10px rounded-4 bottom-7 right-9 text-body-s"
                        style={{ background: '#F4F0FF', width: '120px' }}
                      >
                        {orderRequest.criticalOrder}
                      </div>
                    )}
                    <button
                      className="p-4px rounded-4"
                      style={{ background: '#F4F0FF' }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setCiToolTip(!ciToolTip);
                      }}
                    >
                      <img src={CIIcon}></img>
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}
          {orderRequest.patientName && (
            <div className="flex flex-row items-center mt-8px">
              <img src={patientIcon} alt="patient" className="self-start" />
              <div className="flex flex-col">
                <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                  Patient
                </p>
                <p className="text-chip text-txtsecondary-shades8 ml-8px">
                  {orderRequest.patientName}
                </p>
              </div>
            </div>
          )}
          {orderRequest.address && (
            <div className="flex flex-row items-center mt-8px">
              <img src={AddressIcon} alt="patient" className="self-start" />
              <div className="flex flex-col">
                <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                  {orderRequest.orderDeliveryType === 'home-delivery'
                    ? 'Delivery Address'
                    : 'Pickup Address'}
                </p>
                <p className="text-chip text-txtsecondary-shades8 ml-8px">
                  {orderRequest.address}
                </p>
              </div>
            </div>
          )}
          {/* <div className="flex flex-row items-center mt-8px">
            <img src={calendarIcon} alt="calendar" className="self-start" />
            <div className="flex flex-col">
              <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                Date & Time Slot
              </p>
              <p className="text-chip text-txtsecondary-shades8 ml-8px">
                {orderRequest.slotDateTime}
              </p>
            </div>
          </div> */}
          {orderRequest.orderStatus !== 'select-partner' &&
            orderRequest.partnerName && (
              <div className="flex flex-row items-center justify-between font-bold text-body-m mt-8px w-full">
                <div className="flex">
                  <img
                    src={partnerIcon}
                    alt="calendar"
                    className="self-start"
                  />
                  <div className="flex flex-col">
                    <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                      Partner
                    </p>
                    <p className="text-chip font-regular text-txtsecondary-shades8 ml-8px">
                      {orderRequest.partnerName}
                    </p>
                  </div>
                </div>
                {orderRequest.orderStatus === 'delivered' && (
                  <div className="flex items-center">
                    <img src={DeliveredIcon}></img>
                    <span
                      className="text-body-s text-green-shades5 font-medium ml-4px"
                      style={{
                        color: '#7DCC18',
                      }}
                    >
                      Completed
                    </span>
                  </div>
                )}
                {orderRequest.orderStatus === 'placed' &&
                  orderRequest.orderDeliveryType === 'home-delivery' && (
                    <div className="flex items-center">
                      <EllipseIcon
                        src={ellipseIcon}
                        alt="ellipse"
                        height={11}
                        width={12}
                        className="icon-spin"
                        type={orderRequest.isDelayed ? 'delayed' : 'notDelayed'}
                      />
                      <span
                        className="text-body-s font-medium ml-4px"
                        style={{ color: '#3F8CFF' }}
                      >
                        Confirming
                      </span>
                    </div>
                  )}
                {orderRequest.orderStatus === 'placed' &&
                  orderRequest.orderDeliveryType !== 'home-delivery' &&
                  orderRequest.storeLat &&
                  orderRequest.storeLong && (
                    <button
                      className="w-8 h-8 flex justify-center items-center rounded-12"
                      style={{
                        background: ' rgba(28, 143, 248, 0.1)',
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        window.open(
                          `https://maps.google.com/?q=${orderRequest.storeLat},${orderRequest.storeLong}`,
                          '_blank'
                        );
                      }}
                    >
                      <img src={DirectionIcon}></img>
                    </button>
                  )}
                {orderRequest.orderStatus === 'mix-credit' && (
                  <div className="flex items-center relative">
                    {showTooltip && (
                      <div
                        className="absolute text-body-s font-regular p-10px rounded-8 z-30"
                        style={{
                          width: '200px',
                          top: '-350%',
                          left: '-275%',
                          background: '#F4F0FF',
                        }}
                      >
                        {orderRequest.toolTip}
                      </div>
                    )}
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        showTooltip
                          ? setShowTooltip(false)
                          : setShowTooltip(true);
                      }}
                      className="py-1px px-8px rounded-4 text-body-s"
                      style={{ background: '#F4F0FF' }}
                    >
                      i
                    </button>
                    <p className="ml-12px">₹ {orderRequest.amount}</p>
                  </div>
                )}
              </div>
            )}

          <div
            className="flex flex-row justify-between"
            style={{ width: '100%' }}
          >
            <div className="mt-8px">
              {orderRequest.prescribedTime && (
                <div className="flex flex-row items-start">
                  <img src={DateIcon}></img>
                  <div className="flex flex-col">
                    <p className="text-body-s text-txtlight font-medium ml-8px">
                      Date & Time
                    </p>
                    <p className="text-chip text-txtsecondary-shades8 ml-8px">
                      {orderRequest.prescribedTime}
                    </p>
                  </div>
                </div>
              )}

              {/* <div className="flex flex-row items-center justify-end w-full">
              {orderRequest.orderStatus === 'confirmed' && (
                <>
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="6" cy="6" r="6" fill="#7DCC18" />
                    <path
                      d="M5.00988 6.77701L3.71305 5.6741L3 6.28053L4.71133 7.73597L4.7133 7.73429L5.02572 8L9 4.61822L8.27312 4L5.00988 6.77701Z"
                      fill="white"
                    />
                  </svg>
                  <span className="text-body-s text-green-shades5 font-medium ml-4px">
                    Confirmed
                  </span>
                </>
              )}
              {orderRequest.orderStatus === 'placed' && (
                <>
                  <EllipseIcon
                    src={ellipseIcon}
                    alt="ellipse"
                    height={11}
                    width={12}
                    className="icon-spin"
                    type={orderRequest.isDelayed ? 'delayed' : 'notDelayed'}
                  />
                  <span
                    className="text-body-s font-medium ml-4px"
                    style={{ color: '#3F8CFF' }}
                  >
                    Confirming
                  </span>
                </>
              )}
              {orderRequest.orderStatus === 'cancelled' && (
                <>
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8Z"
                      fill="#FF754C"
                    />
                    <path
                      d="M10.293 11L11 10.293L8.70703 7.99999L11 5.70703L10.293 5L8.00001 7.29297L5.70703 5L5 5.70703L7.29297 7.99999L5 10.293L5.70703 11L8.00001 8.70704L10.293 11Z"
                      fill="white"
                    />
                  </svg>
                  <span className="text-body-s text-accent2-shades4 font-medium ml-4px">
                    Cancelled
                  </span>
                </>
              )}
            </div> */}
            </div>
            <div style={providerLogoContainerStyles}>
              {orderRequest.partnersLogo &&
                orderRequest.partnersLogo
                  .filter((logo) => logo)
                  .map((item, index, array) => {
                    return item ? (
                      <div key={index}>
                        <img
                          src={item}
                          style={{
                            ...providerLogoStyles,
                            zIndex: 1,
                            right: `${(array.length - 1 - index) * -20}px`,
                          }}
                        />
                      </div>
                    ) : (
                      <div />
                    );
                  })}
            </div>
          </div>
        </div>
        {orderRequest.status === 'Delayed' && (
          <button
            className="flex justify-center w-full text-center py-12px text-body-s text-primary font-semibold tracking-wide"
            onClick={openSupport}
          >
            Contact Support
          </button>
        )}
        {orderStatus === 'cart-created' && (
          <button
            className="flex justify-center w-full text-center py-12px text-body-s text-primary font-semibold tracking-wide"
            onClick={(e) => {
              e.stopPropagation();
              history.push('/pharmacy/order-review', {
                cartId: orderRequest.cartId,
              });
              logEvent('Pharmacy Review Medicines Screen', {
                sponsorId: user.sponsorName,
                sponsorId: user.sponsorId,
              });
            }}
          >
            Place Order
          </button>
        )}
        {orderStatus === 'select-partner' && (
          <button
            className="flex justify-center w-full text-center py-12px text-body-s text-primary font-semibold tracking-wide"
            onClick={(e) => {
              e.stopPropagation();
              history.push('/pharmacy/select-partner', {
                cartId: orderRequest.cartId,
                digitisationId: orderRequest.digitisationId,
                isReOrderCart: orderRequest.isReOrderCart,
              });
              // logEvent('Pharmacy Review Medicines Screen', {
              //   sponsorId: user.sponsorName,
              //   sponsorId: user.sponsorId,
              // });
            }}
          >
            View Partners
          </button>
        )}
      </div>
    );
  } else if (type === 'samplePickUp') {
    return (
      <div
        className="hover pt-16px mt-16px rounded-12"
        style={{
          border: `1px solid ${orderRequest.isDelayed ? '#FF754C' : '#E6E9EC'}`,
        }}
        onClick={onTap}
      >
        <div className="flex flex-row justify-between items-center px-16px pb-20px border-b border-solid border-txtsecondary-shades4">
          <div className="flex">
            <IconContainer color={type} style={{ padding: '12px 10.50px' }}>
              <img
                src={samplePickUpIcon}
                alt="sample-pickup"
                style={{ minWidth: '19.76px', minHeight: '16.85px' }}
              />
            </IconContainer>
            <div className="flex flex-col">
              <span className="text-title-s font-semibold text-txtlight">
                {orderRequest.title}
              </span>
              <div className="text-chip font-medium mt-2px text-sub">
                {orderRequest.infoText}
              </div>
            </div>
          </div>
          <ScreenIcon
            className="float-right self-start"
            src={arrowRight}
            alt="right"
            type={orderRequest.isDelayed ? 'delayed' : 'notDelayed'}
          />
        </div>
        <div
          className="flex flex-col items-start pb-12px px-16px"
          style={{
            marginTop: '12px',
            borderBottom: '1px solid #F0F3F6',
          }}
        >
          <div className="flex flex-row">
            <img src={clockIcon} alt="prescribed-time" className="self-start" />
            <div className="flex flex-col">
              <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                Order ID - {orderRequest.orderId}
              </p>
              <p className="text-chip text-txtsecondary-shades8 ml-8px">
                Booked on {orderRequest.bookedOnDate}
              </p>
            </div>
          </div>
          <div className="flex flex-row items-center mt-8px">
            {orderRequest.testsType === 'pathology' && (
              <img src={PathologyIcon} alt="test type" className="self-start" />
            )}
            {orderRequest.testsType === 'radiology' && (
              <img
                src={RadiologyIcon}
                alt="test type"
                className="self-start"
                style={{ paddingLeft: '3px', marginRight: '3px' }}
              />
            )}
            <div className="flex flex-col">
              <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                Tests Booked - {orderRequest.testsTypeName}
              </p>
              <p className="text-chip text-txtsecondary-shades8 ml-8px">
                {orderRequest.testNames}
              </p>
            </div>
          </div>
          <div className="flex flex-row items-center mt-8px">
            <img src={patientIcon} alt="patient" className="self-start" />
            <div className="flex flex-col">
              <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                Patient
              </p>
              <p className="text-chip text-txtsecondary-shades8 ml-8px">
                {orderRequest.patientName}
              </p>
            </div>
          </div>
          <div className="flex flex-row items-center mt-8px">
            <img src={calendarIcon} alt="calendar" className="self-start" />
            <div className="flex flex-col">
              <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                Date & Time Slot
              </p>
              <p className="text-chip text-txtsecondary-shades8 ml-8px">
                {orderRequest.slotDateTime}
              </p>
            </div>
          </div>
          {/* {orderRequest.partnerName && } */}
          <div className="flex flex-row items-center justify-between mt-8px w-full">
            <div className="flex flex-row items-center">
              <img src={partnerIcon} alt="calendar" className="self-start" />
              <div className="flex flex-col">
                <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                  Partner
                </p>
                <p className="text-chip text-txtsecondary-shades8 ml-8px">
                  {orderRequest.partnerName}
                </p>
              </div>
            </div>

            <div className="flex flex-row items-center">
              <EllipseIcon
                src={ellipseIcon}
                alt="ellipse"
                height={11}
                width={12}
                className="icon-spin"
                type={orderRequest.isDelayed ? 'delayed' : 'notDelayed'}
              />
              <span
                className="text-body-s font-medium ml-4px"
                style={{
                  color: `${!orderRequest.isDelayed ? '#3F8CFF' : '#FF754C'}`,
                }}
              >
                {orderRequest.isDelayed ? 'Delayed' : 'Confirming'}
              </span>
            </div>
          </div>
        </div>
        {orderRequest.showEmergencyButtonCall && (
          <div
            className="text-center text-body-s text-primary font-semibold py-12px w-full border-t border-solid border-txtsecondary-shades4 tracking-wide"
            onClick={emergencyCallHandler}
          >
            {orderRequest.isDelayed &&
              !orderRequest.orderId &&
              'Contact Support'}
            {orderRequest.orderId && 'Request Callback'}
          </div>
        )}
        {orderRequest.questionToAsk && (
          <div>
            <div className="text-center text-body-s text-txtlight font-semibold py-12px w-full border-t border-solid border-txtsecondary-shades4 tracking-wide">
              {orderRequest.questionToAsk}
            </div>
            <div className="text-center text-body-s font-semibold py-12px w-full border-t border-solid border-txtsecondary-shades4 tracking-wide flex flex-row items-center">
              <div
                className="text-primary flex-1"
                onClick={(e) => {
                  e.stopPropagation();
                  postSamplePickup(authToken, true, orderRequest.orderId);
                }}
              >
                Yes, on time!
              </div>
              <div
                style={{ minHeight: '18px', border: '1px solid #F0F3F6' }}
              ></div>
              <div
                className="flex-1"
                style={{ color: '#F25540' }}
                onClick={(e) => {
                  e.stopPropagation();
                  postSamplePickup(authToken, false);
                }}
              >
                No, not yet!
              </div>
            </div>
          </div>
        )}
        {modalDetails.showModal && (
          <ErrorModal>
            <ModalContainer onClick={hideModal}>
              <ModalBody onClick={(e) => e.stopPropagation()}>
                <CloseContainer onClick={(e) => hideModal(e)}>
                  <FaTimes />
                </CloseContainer>
                <ModalIcon
                  onClick={(e) => e.stopPropagation()}
                  src={modalIcon}
                />
                <ModalText onClick={(e) => e.stopPropagation()}>
                  {modalDetails.modalText}
                </ModalText>
              </ModalBody>
            </ModalContainer>
          </ErrorModal>
        )}
      </div>
    );
  } else if (type === 'partnerConfirmation' || type === 'partnerConfirmed') {
    return (
      <div
        className="hover pt-16px mt-16px rounded-12"
        style={{
          border: `1px solid ${orderRequest.isDelayed ? '#FF754C' : '#E6E9EC'}`,
        }}
        onClick={onTap}
      >
        <div className="flex flex-row justify-between items-center px-16px pb-20px border-b border-solid border-txtsecondary-shades4">
          <div className="flex">
            <IconContainer color={type} style={{ padding: '12px 9px' }}>
              <img
                src={partnerConfirmIcon}
                alt="sample-pickup"
                style={{ minWidth: '23.1px', minHeight: '15.23px' }}
              />
            </IconContainer>
            <div className="flex flex-col">
              <span className="text-title-s font-semibold text-txtlight">
                {orderRequest.title}
              </span>
              <div className="text-chip font-medium mt-2px text-sub">
                {orderRequest.infoText}
              </div>
            </div>
          </div>
          <ScreenIcon
            className="float-right self-start"
            src={arrowRight}
            alt="right"
            type={orderRequest.isDelayed ? 'delayed' : 'notDelayed'}
          />
        </div>
        <div
          className="flex flex-col items-start pb-12px px-16px"
          style={{
            marginTop: '12px',
            borderBottom: '1px solid #F0F3F6',
          }}
        >
          <div className="flex flex-row">
            <img src={clockIcon} alt="prescribed-time" className="self-start" />
            <div className="flex flex-col">
              <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                Order ID - {orderRequest.orderId}
              </p>
              <p className="text-chip text-txtsecondary ml-8px">
                Booked on {orderRequest.bookedOnDate}
              </p>
            </div>
          </div>
          <div className="flex flex-row items-center mt-8px">
            {orderRequest.testsType === 'pathology' && (
              <img src={PathologyIcon} alt="test type" className="self-start" />
            )}
            {orderRequest.testsType === 'radiology' && (
              <img
                src={RadiologyIcon}
                alt="test type"
                className="self-start"
                style={{ paddingLeft: '3px', marginRight: '3px' }}
              />
            )}
            <div className="flex flex-col">
              <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                Tests Booked - {orderRequest.testsTypeName}
              </p>
              <p className="text-chip text-txtsecondary ml-8px">
                {orderRequest.testNames}
              </p>
            </div>
          </div>
          <div className="flex flex-row items-center mt-8px">
            <img src={patientIcon} alt="patient" className="self-start" />
            <div className="flex flex-col">
              <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                Patient
              </p>
              <p className="text-chip text-txtsecondary ml-8px">
                {orderRequest.patientName}
              </p>
            </div>
          </div>
          <div className="flex flex-row items-center mt-8px">
            <img src={calendarIcon} alt="calendar" className="self-start" />
            <div className="flex flex-col">
              <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                Date & Time Slot
              </p>
              <p className="text-chip text-txtsecondary ml-8px">
                {orderRequest.slotDateTime}
              </p>
            </div>
          </div>
          {/* {orderRequest.partnerName && } */}
          <div className="flex flex-row items-center justify-between mt-8px w-full">
            <div className="flex flex-row items-center">
              <img src={partnerIcon} alt="calendar" className="self-start" />
              <div className="flex flex-col">
                <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                  Partner
                </p>
                <p className="text-chip text-txtsecondary ml-8px">
                  {orderRequest.partnerName}
                </p>
              </div>
            </div>
            <div className="flex flex-row items-center">
              {orderRequest.isDelayed ? (
                <>
                  <EllipseIcon
                    src={ellipseIcon}
                    alt="ellipse"
                    height={11}
                    width={12}
                    className="icon-spin"
                    type={orderRequest.isDelayed ? 'delayed' : 'notDelayed'}
                  />
                  <span
                    className="text-body-s font-medium ml-4px"
                    style={{
                      color: `${
                        !orderRequest.isDelayed ? '#3F8CFF' : '#FF754C'
                      }`,
                    }}
                  >
                    Delayed
                  </span>{' '}
                </>
              ) : (
                <>
                  <img src={partnerNameIcon} alt="lab" className="self-start" />
                  <p className="text-body-s font-medium text-primary ml-4px">
                    {orderRequest.partnerName}
                  </p>
                </>
              )}
            </div>
          </div>
        </div>
        {orderRequest.showEmergencyButtonCall ? (
          <div
            className="text-center text-body-s text-primary font-semibold py-12px w-full border-t border-solid border-txtsecondary-shades4 tracking-wide"
            onClick={emergencyCallHandler}
          >
            {orderRequest.isDelayed &&
              !orderRequest.orderId &&
              'Contact Support'}
            {orderRequest.orderId && 'Request Callback'}
          </div>
        ) : (
          <div></div>
        )}
        {modalDetails.showModal && (
          <ErrorModal>
            <ModalContainer onClick={hideModal}>
              <ModalBody onClick={(e) => e.stopPropagation()}>
                <CloseContainer onClick={(e) => hideModal(e)}>
                  <FaTimes />
                </CloseContainer>
                <ModalIcon
                  onClick={(e) => e.stopPropagation()}
                  src={modalIcon}
                />
                <ModalText onClick={(e) => e.stopPropagation()}>
                  {modalDetails.modalText}
                </ModalText>
              </ModalBody>
            </ModalContainer>
          </ErrorModal>
        )}
      </div>
    );
  } else if (type === 'sampleProcessing') {
    return (
      <div
        className="hover pt-16px mt-16px rounded-12"
        style={{
          border: `1px solid ${orderRequest.isDelayed ? '#FF754C' : '#E6E9EC'}`,
        }}
        onClick={onTap}
      >
        <div className="flex flex-row justify-between items-center px-16px pb-20px border-b border-solid border-txtsecondary-shades4">
          <div className="flex">
            <IconContainer color={type} style={{ padding: '11px 12px' }}>
              <img
                src={sampleProcessingIcon}
                alt="sample-pickup"
                style={{ minWidth: '16.64px', minHeight: '17.05px' }}
              />
            </IconContainer>
            <div className="flex flex-col">
              <span className="text-title-s font-semibold text-txtlight">
                {orderRequest.title}
              </span>
              <div className="text-chip font-medium mt-2px text-sub">
                {orderRequest.infoText}
              </div>
            </div>
          </div>
          <ScreenIcon
            className="float-right self-start"
            src={arrowRight}
            alt="right"
            type={orderRequest.isDelayed ? 'delayed' : 'notDelayed'}
          />
        </div>
        <div
          className="flex flex-col items-start pb-12px px-16px"
          style={{
            marginTop: '12px',
            borderBottom: '1px solid #F0F3F6',
          }}
        >
          <div className="flex flex-row">
            <img src={clockIcon} alt="prescribed-time" className="self-start" />
            <div className="flex flex-col">
              <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                Order ID - {orderRequest.orderId}
              </p>
              <p className="text-chip text-txtsecondary-shades8 ml-8px">
                Booked on {orderRequest.bookedOnDate}
              </p>
            </div>
          </div>
          <div className="flex flex-row items-center mt-8px">
            {orderRequest.testsType === 'pathology' && (
              <img src={PathologyIcon} alt="test type" className="self-start" />
            )}
            {orderRequest.testsType === 'radiology' && (
              <img
                src={RadiologyIcon}
                alt="test type"
                className="self-start"
                style={{ paddingLeft: '3px', marginRight: '3px' }}
              />
            )}
            <div className="flex flex-col">
              <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                Tests Booked - {orderRequest.testsTypeName}
              </p>
              <p className="text-chip text-txtsecondary-shades8 ml-8px">
                {orderRequest.testNames}
              </p>
            </div>
          </div>
          <div className="flex flex-row items-center mt-8px">
            <img src={patientIcon} alt="patient" className="self-start" />
            <div className="flex flex-col">
              <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                Patient
              </p>
              <p className="text-chip text-txtsecondary-shades8 ml-8px">
                {orderRequest.patientName}
              </p>
            </div>
          </div>
          <div className="flex flex-row items-center mt-8px">
            <img src={calendarIcon} alt="calendar" className="self-start" />
            <div className="flex flex-col">
              <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                Date & Time Slot
              </p>
              <p className="text-chip text-txtsecondary-shades8 ml-8px">
                {orderRequest.slotDateTime}
              </p>
            </div>
          </div>
          {/* {orderRequest.partnerName && } */}
          <div className="flex flex-row items-center justify-between mt-8px w-full">
            <div className="flex flex-row items-center">
              <img src={partnerIcon} alt="calendar" className="self-start" />
              <div className="flex flex-col">
                <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                  Partner
                </p>
                <p className="text-chip text-txtsecondary-shades8 ml-8px">
                  {orderRequest.partnerName}
                </p>
              </div>
            </div>
            <div className="flex flex-row items-center">
              <EllipseIcon
                src={ellipseIcon}
                alt="ellipse"
                height={11}
                width={12}
                className="icon-spin"
                type={orderRequest.isDelayed ? 'delayed' : 'notDelayed'}
              />
              <span
                className="text-body-s font-medium ml-4px"
                style={{
                  color: `${!orderRequest.isDelayed ? '#3F8CFF' : '#FF754C'}`,
                }}
              >
                {orderRequest.isDelayed ? 'Delayed' : 'Reports Awaited'}
              </span>
            </div>
          </div>
        </div>
        {orderRequest.showEmergencyButtonCall ? (
          <div
            className="text-center text-body-s text-primary font-semibold py-12px w-full border-t border-solid border-txtsecondary-shades4 tracking-wide"
            onClick={emergencyCallHandler}
          >
            {orderRequest.isDelayed &&
              !orderRequest.orderId &&
              'Contact Support'}
            {orderRequest.orderId && 'Request Callback'}
          </div>
        ) : (
          <div></div>
        )}
        {modalDetails.showModal && (
          <ErrorModal>
            <ModalContainer onClick={hideModal}>
              <ModalBody onClick={(e) => e.stopPropagation()}>
                <CloseContainer onClick={(e) => hideModal(e)}>
                  <FaTimes />
                </CloseContainer>
                <ModalIcon
                  onClick={(e) => e.stopPropagation()}
                  src={modalIcon}
                />
                <ModalText onClick={(e) => e.stopPropagation()}>
                  {modalDetails.modalText}
                </ModalText>
              </ModalBody>
            </ModalContainer>
          </ErrorModal>
        )}
      </div>
    );
  } else if (type === 'reportGenerated') {
    return (
      <div
        className="hover pt-16px mt-16px rounded-12"
        style={{
          border: `1px solid ${
            orderRequest.completedRemarks ? '#7DCC18' : '#E6E9EC'
          }`,
        }}
        onClick={(e) => {
          e.stopPropagation();
          onTap();
        }}
      >
        <div className="flex flex-row justify-between items-center px-16px pb-20px border-b border-solid border-txtsecondary-shades4">
          <div className="flex">
            <IconContainer color={type} style={{ padding: '11px 12px' }}>
              <img
                src={sampleProcessingIcon}
                alt="sample-pickup"
                style={{ minWidth: '16.64px', minHeight: '17.05px' }}
              />
            </IconContainer>
            <div className="flex flex-col">
              <span className="text-title-s font-semibold text-txtlight">
                {orderRequest.title}
              </span>
              <div className="text-chip font-medium mt-2px text-sub">
                {orderRequest.infoText}
              </div>
            </div>
          </div>
          <ScreenIcon
            className="float-right self-start"
            src={arrowRight}
            alt="right"
            type={orderRequest.isDelayed ? 'delayed' : 'notDelayed'}
          />
        </div>
        <div
          className="flex flex-col items-start pb-12px px-16px"
          style={{
            marginTop: '12px',
            borderBottom: '1px solid #F0F3F6',
          }}
        >
          <div className="flex flex-row">
            <img src={clockIcon} alt="prescribed-time" className="self-start" />
            <div className="flex flex-col">
              <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                Order ID - {orderRequest.orderId}
              </p>
              <p className="text-chip text-txtsecondary-shades8 ml-8px">
                Booked on {orderRequest.bookedOnDate}
              </p>
            </div>
          </div>
          <div className="flex flex-row items-center mt-8px">
            {orderRequest.testsType === 'pathology' && (
              <img src={PathologyIcon} alt="test type" className="self-start" />
            )}
            {orderRequest.testsType === 'radiology' && (
              <img
                src={RadiologyIcon}
                alt="test type"
                className="self-start"
                style={{ paddingLeft: '3px', marginRight: '3px' }}
              />
            )}
            <div className="flex flex-col">
              <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                Tests Booked - {orderRequest.testsTypeName}
              </p>
              <p className="text-chip text-txtsecondary-shades8 ml-8px">
                {orderRequest.testNames}
              </p>
            </div>
          </div>
          <div className="flex flex-row items-center mt-8px">
            <img src={patientIcon} alt="patient" className="self-start" />
            <div className="flex flex-col">
              <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                Patient
              </p>
              <p className="text-chip text-txtsecondary-shades8 ml-8px">
                {orderRequest.patientName}
              </p>
            </div>
          </div>
          <div className="flex flex-row items-center mt-8px">
            <img src={calendarIcon} alt="calendar" className="self-start" />
            <div className="flex flex-col">
              <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                Date & Time Slot
              </p>
              <p className="text-chip text-txtsecondary-shades8 ml-8px">
                {orderRequest.slotDateTime}
              </p>
            </div>
          </div>
          {/* {orderRequest.partnerName && } */}
          <div className="flex flex-row items-center justify-between mt-8px w-full">
            <div className="flex flex-row items-center">
              <img src={partnerIcon} alt="calendar" className="self-start" />
              <div className="flex flex-col">
                <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                  Partner
                </p>
                <p className="text-chip text-txtsecondary-shades8 ml-8px">
                  {orderRequest.partnerName}
                </p>
              </div>
            </div>
            <div className="flex flex-row items-center">
              {orderRequest.completedRemarks ? (
                <>
                  <img src={completedEarlyIcon} alt="completed-icon" />
                  <span
                    className="text-body-s font-medium ml-4px"
                    style={{
                      color: `#7DCC18`,
                    }}
                  >
                    {orderRequest.completedRemarks}
                  </span>
                </>
              ) : (
                <>
                  <img src={completedIcon} alt="completed-icon" />
                  <span
                    className="text-body-s font-medium ml-4px"
                    style={{
                      color: `#7DCC18`,
                    }}
                  >
                    Complete
                  </span>
                </>
              )}
            </div>
          </div>
        </div>
        <button
          onClick={(e) => {
            e.stopPropagation();
            window.location.href = orderRequest.reportUrl;
          }}
          className="py-16px px-20px w-full border-t border-solid border-txtsecondary-shades4 tracking-wide"
        >
          <p
            // href={`${orderRequest.reportUrl}`}
            className="bg-primary text-center py-12px rounded-12 text-body-s font-bold block"
            style={{ color: 'white' }}
          >
            Download Report
          </p>
        </button>
        <div className="py-16px px-20px w-full border-t border-solid border-txtsecondary-shades4 tracking-wide text-center text-sub text-chip font-medium">
          {orderRequest.description}
        </div>
        <div
          className="py-16px w-full border-t border-solid border-txtsecondary-shades4 tracking-wide text-center text-primary text-body-s font-semibold"
          onClick={(e) => {
            e.stopPropagation();
            history.push('/consultation/start');
          }}
        >
          Consult Doctor
        </div>
      </div>
    );
  } else if (type === 'partialReportGenerated') {
    return (
      <div
        className="hover pt-16px mt-16px rounded-12"
        style={{
          border: '1px solid #E6E9EC',
        }}
        onClick={(e) => {
          e.stopPropagation();
          onTap();
        }}
      >
        <div className="flex flex-row justify-between items-center px-16px pb-20px border-b border-solid border-txtsecondary-shades4">
          <div className="flex">
            <IconContainer color={type} style={{ padding: '11px 12px' }}>
              <img
                src={sampleProcessingIcon}
                alt="sample-pickup"
                style={{ minWidth: '16.64px', minHeight: '17.05px' }}
              />
            </IconContainer>
            <div className="flex flex-col">
              <span className="text-title-s font-semibold text-txtlight">
                {orderRequest.title}
              </span>
              <div className="text-chip font-medium mt-2px text-sub">
                {orderRequest.infoText}
              </div>
            </div>
          </div>
          <ScreenIcon
            className="float-right self-start"
            src={arrowRight}
            alt="right"
            type={orderRequest.isDelayed ? 'delayed' : 'notDelayed'}
          />
        </div>
        <div
          className="flex flex-col items-start pb-12px px-16px"
          style={{
            marginTop: '12px',
            borderBottom: '1px solid #F0F3F6',
          }}
        >
          <div className="flex flex-row">
            <img src={clockIcon} alt="prescribed-time" className="self-start" />
            <div className="flex flex-col">
              <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                Order ID - {orderRequest.orderId}
              </p>
              <p className="text-chip text-txtsecondary-shades8 ml-8px">
                Booked on {orderRequest.bookedOnDate}
              </p>
            </div>
          </div>
          <div className="flex flex-row items-center mt-8px">
            {orderRequest.testsType === 'pathology' && (
              <img src={PathologyIcon} alt="test type" className="self-start" />
            )}
            {orderRequest.testsType === 'radiology' && (
              <img
                src={RadiologyIcon}
                alt="test type"
                className="self-start"
                style={{ paddingLeft: '3px', marginRight: '3px' }}
              />
            )}
            <div className="flex flex-col">
              <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                Tests Booked - {orderRequest.testsTypeName}
              </p>
              <p className="text-chip text-txtsecondary-shades8 ml-8px">
                {orderRequest.testNames}
              </p>
            </div>
          </div>
          <div className="flex flex-row items-center mt-8px">
            <img src={patientIcon} alt="patient" className="self-start" />
            <div className="flex flex-col">
              <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                Patient
              </p>
              <p className="text-chip text-txtsecondary-shades8 ml-8px">
                {orderRequest.patientName}
              </p>
            </div>
          </div>
          <div className="flex flex-row items-center mt-8px">
            <img src={calendarIcon} alt="calendar" className="self-start" />
            <div className="flex flex-col">
              <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                Date & Time Slot
              </p>
              <p className="text-chip text-txtsecondary-shades8 ml-8px">
                {orderRequest.slotDateTime}
              </p>
            </div>
          </div>
          {/* {orderRequest.partnerName && } */}
          <div className="flex flex-row items-center justify-between mt-8px w-full">
            <div className="flex flex-row items-center">
              <img src={partnerIcon} alt="calendar" className="self-start" />
              <div className="flex flex-col">
                <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                  Partner
                </p>
                <p className="text-chip text-txtsecondary-shades8 ml-8px">
                  {orderRequest.partnerName}
                </p>
              </div>
            </div>
            <div className="flex flex-row items-center">
              <EllipseIcon
                src={ellipseIcon}
                alt="ellipse"
                height={11}
                width={12}
                className="icon-spin"
                type={type}
              />
              <span
                className="text-body-s font-medium ml-4px"
                style={{
                  color: `#3F8CFF`,
                }}
              >
                Reports Awaited
              </span>
            </div>
          </div>
        </div>
        <button
          onClick={(e) => {
            e.stopPropagation();
            window.location.href = orderRequest.reportUrl;
          }}
          className="py-16px px-20px w-full border-t border-solid border-txtsecondary-shades4 tracking-wide"
        >
          <p
            className="bg-primary text-center py-12px rounded-12 text-body-s font-bold block"
            style={{ color: 'white' }}
          >
            Download Report
          </p>
        </button>
      </div>
    );
  } else if (type === 'orderCancelled') {
    return (
      <div
        className="hover pt-16px mt-16px rounded-12"
        style={{
          border: '1px solid #E6E9EC',
        }}
        onClick={onTap}
      >
        <div className="flex flex-row justify-between items-center px-16px pb-20px border-b border-solid border-txtsecondary-shades4">
          <div className="flex">
            <IconContainer
              color={type}
              style={{ border: '1px solid #FF754C', padding: '11px' }}
            >
              <img
                src={newCrossIcon}
                alt="cancelled"
                style={{ minWidth: '18px', minHeight: '18px' }}
              />
            </IconContainer>
            <div className="flex flex-col">
              <span className="text-title-s font-semibold text-txtlight">
                {orderRequest.title
                  ? orderRequest.title
                  : orderRequest.testNames}
              </span>
              <div className="text-chip font-medium mt-2px text-sub">
                Reason : {orderRequest.reason}
              </div>
            </div>
          </div>
          <ScreenIcon
            className="float-right self-start"
            src={arrowRight}
            alt="right"
            style={{ filter: 'brightness(0) saturate(100%)' }}
          />
        </div>
        <div
          className="flex flex-col items-start pb-12px px-16px"
          style={{
            marginTop: '12px',
            borderBottom: '1px solid #F0F3F6',
          }}
        >
          <div className="flex flex-row items-center justify-between w-full">
            <div className="flex flex-row">
              <img src={patientIcon} alt="patient" className="self-start" />
              <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                {orderRequest.patientName}
              </p>
            </div>
            <div className="flex flex-row items-center">
              {orderRequest.testsType === 'pathology' && (
                <img
                  src={PathologyGreenIcon}
                  alt="test type"
                  className="self-start"
                />
              )}
              {orderRequest.testsType === 'radiology' && (
                <img
                  src={RadiologyIcon}
                  alt="test type"
                  className="self-start"
                />
              )}
              {orderRequest.testsType === 'vaccination' && (
                <img src={SyringeIcon} alt="test type" className="self-start" />
              )}
              <p className="text-body-s text-txtlight ml-8px">
                {orderRequest.testsTypeName}
              </p>
            </div>
          </div>
          <div className="flex flex-row items-center justify-between w-full mt-8px">
            <div className="flex flex-row">
              <ScreenIcon
                src={clockIcon}
                alt="patient"
                className="self-start"
                type="delayed"
              />
              <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                {orderRequest.cancelledOn}
              </p>
            </div>
            <div className="flex flex-row items-center">
              <img src={crossFillIcon} alt="cancelled" />
              <p className="text-body-s text-accent2-shades4 ml-4px font-semibold">
                Cancelled
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  } else if (type === 'copay') {
    return (
      <div
        className="hover pt-16px mt-16px rounded-12"
        style={{
          border: `1px solid ${orderRequest.isDelayed ? '#FF754C' : '#E6E9EC'}`,
        }}
        onClick={onTap}
      >
        <div className="flex flex-row justify-between items-center px-16px pb-20px border-b border-solid border-txtsecondary-shades4">
          <div className="flex">
            <IconContainer
              color={type}
              style={{ padding: '10px', paddingRight: '9.59px' }}
            >
              <img
                src={copayWalletIcon}
                alt="copay"
                style={{ minWidth: '20.81px', minHeight: '20.41px' }}
              />
            </IconContainer>
            <div className="flex flex-col">
              <span className="text-title-s font-semibold text-txtlight">
                {orderRequest.title}
              </span>
              <div className="text-chip font-medium mt-2px text-sub">
                {orderRequest.infoText}
              </div>
            </div>
          </div>
          <ScreenIcon
            className="float-right self-start"
            src={arrowRight}
            alt="right"
            type={orderRequest.isDelayed ? 'delayed' : 'notDelayed'}
          />
        </div>
        <div
          className="flex flex-col items-start pb-12px px-16px"
          style={{
            marginTop: '12px',
            borderBottom: '1px solid #F0F3F6',
          }}
        >
          <div className="flex flex-row">
            <img src={clockIcon} alt="prescribed-time" className="self-start" />
            <div className="flex flex-col">
              <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                Order ID - {orderRequest.orderId}
              </p>
              <p className="text-chip text-txtsecondary ml-8px">
                Booked on {orderRequest.bookedOnDate}
              </p>
            </div>
          </div>
          <div className="flex flex-row items-center mt-8px">
            {orderRequest.testsType === 'pathology' && (
              <img src={PathologyIcon} alt="test type" className="self-start" />
            )}
            {orderRequest.testsType === 'radiology' && (
              <img
                src={RadiologyIcon}
                alt="test type"
                className="self-start"
                style={{ paddingLeft: '3px', marginRight: '3px' }}
              />
            )}
            <div className="flex flex-col">
              <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                Tests Booked - {orderRequest.testsTypeName}
              </p>
              <p className="text-chip text-txtsecondary-shades8 ml-8px">
                {orderRequest.testNames}
              </p>
            </div>
          </div>
          <div className="flex flex-row items-center mt-8px">
            <img src={patientIcon} alt="patient" className="self-start" />
            <div className="flex flex-col">
              <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                Patient
              </p>
              <p className="text-chip text-txtsecondary-shades8 ml-8px">
                {orderRequest.patientName}
              </p>
            </div>
          </div>
          <div className="flex flex-row items-center mt-8px">
            <img src={calendarIcon} alt="calendar" className="self-start" />
            <div className="flex flex-col">
              <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                Date & Time Slot
              </p>
              <p className="text-chip text-txtsecondary-shades8 ml-8px">
                {orderRequest.slotDateTime}
              </p>
            </div>
          </div>
          {/* {orderRequest.partnerName && } */}
          <div className="flex flex-row items-center justify-between mt-8px w-full">
            <div className="flex flex-row items-center">
              <img src={partnerIcon} alt="calendar" className="self-start" />
              <div className="flex flex-col">
                <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                  Partner
                </p>
                <p className="text-chip text-txtsecondary-shades8 ml-8px">
                  {orderRequest.partnerName}
                </p>
              </div>
            </div>
            <div className="flex flex-row items-center">
              <Tooltip content={orderRequest.pendingCopayText}>
                <img src={copayIcon} alt="copay" />
              </Tooltip>
              <p className="text-body-l text-txtlight font-bold ml-8px">
                ₹ {orderRequest.pendingCopayAmount}
              </p>
            </div>
          </div>
        </div>
        <div
          className="py-12px text-center text-body-l font-semibold text-primary"
          onClick={(e) => {
            e.stopPropagation();
            payLabCopay(orderRequest.orderId, history, authToken);
          }}
        >
          Make Payment
        </div>
      </div>
    );
  } else if (
    type === 'orderUpdate' ||
    type === 'orderUpdatePartner' ||
    type === 'orderUpdateReschedule'
  ) {
    return (
      <div
        className="hover pt-16px mt-16px rounded-12"
        style={{
          border: `1px solid #E6E9EC`,
        }}
        onClick={onTap}
      >
        <div className="flex flex-row justify-between items-center px-16px pb-20px border-b border-solid border-txtsecondary-shades4">
          <div className="flex">
            <IconContainer color={type} style={{ padding: '12px 9px' }}>
              <img
                src={partnerConfirmIcon}
                alt="order-update"
                style={{ minWidth: '23.1px', minHeight: '15.23px' }}
              />
            </IconContainer>
            <div className="flex flex-col">
              <span className="text-title-s font-semibold text-txtlight">
                {orderRequest.title}
              </span>
              <div className="text-chip font-medium mt-2px text-sub">
                {orderRequest.infoText}
              </div>
            </div>
          </div>
          <ScreenIcon
            className="float-right self-start"
            src={arrowRight}
            alt="right"
            type={orderRequest.isDelayed ? 'delayed' : 'notDelayed'}
          />
        </div>
        <div
          className="flex flex-col items-start pb-12px px-16px"
          style={{
            marginTop: '12px',
            borderBottom: '1px solid #F0F3F6',
          }}
        >
          <div className="flex flex-row">
            <img src={clockIcon} alt="prescribed-time" className="self-start" />
            <div className="flex flex-col">
              <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                Order ID - {orderRequest.orderId}
              </p>
              <p className="text-chip text-txtsecondary ml-8px">
                Booked on {orderRequest.bookedOnDate}
              </p>
            </div>
          </div>
          <div className="flex flex-row items-center mt-8px">
            {orderRequest.testsType === 'pathology' && (
              <img src={PathologyIcon} alt="test type" className="self-start" />
            )}
            {orderRequest.testsType === 'radiology' && (
              <img
                src={RadiologyIcon}
                alt="test type"
                className="self-start"
                style={{ paddingLeft: '3px', marginRight: '3px' }}
              />
            )}
            <div className="flex flex-col">
              <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                Tests Booked - {orderRequest.testsTypeName}
              </p>
              <p className="text-chip text-txtsecondary ml-8px">
                {orderRequest.testNames}
              </p>
            </div>
          </div>
          <div className="flex flex-row items-center mt-8px">
            <img src={patientIcon} alt="patient" className="self-start" />
            <div className="flex flex-col">
              <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                Patient
              </p>
              <p className="text-chip text-txtsecondary ml-8px">
                {orderRequest.patientName}
              </p>
            </div>
          </div>
          <div className="flex justify-between items-center w-full">
            <div className="flex flex-row items-center mt-8px">
              <img src={calendarIcon} alt="calendar" className="self-start" />
              <div className="flex flex-col">
                <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                  Date & Time Slot
                </p>
                <p className="text-chip text-txtsecondary ml-8px">
                  {orderRequest.slotDateTime}
                </p>
              </div>
            </div>
            {type === 'orderUpdate' && (
              <div>
                <div className="flex justify-end items-center">
                  <img src={oldTimeIcon} alt="clock" />
                  <p className="text-chip font-medium text-txtsecondary-shades8 ml-2px line-through">
                    {orderRequest.oldTime}
                  </p>
                </div>
                <div className="flex justify-end items-center">
                  <img src={newTimeIcon} alt="clock" />
                  <p className="text-body-l font-medium text-primary ml-4px">
                    {orderRequest.slotDateTime}
                  </p>
                </div>
              </div>
            )}
          </div>
          {/* {orderRequest.partnerName && } */}
          <div className="flex flex-row items-center justify-between mt-8px w-full">
            <div className="flex flex-row items-center">
              <img src={partnerIcon} alt="calendar" className="self-start" />
              <div className="flex flex-col">
                <p className="text-body-s text-txtlight font-medium ml-8px w-full">
                  Partner
                </p>
                <p className="text-chip text-txtsecondary ml-8px">
                  {orderRequest.partnerName}
                </p>
              </div>
            </div>
            <div className="flex flex-row items-center">
              {type === 'orderUpdateReschedule' && (
                <div>
                  <div className="flex justify-end items-center">
                    <img src={oldTimeIcon} alt="clock" />
                    <p className="text-chip font-medium text-txtsecondary-shades8 ml-2px line-through">
                      {orderRequest.oldTime}
                    </p>
                  </div>
                  <div className="flex justify-end items-center">
                    <img src={newTimeIcon} alt="clock" />
                    <p className="text-body-l font-medium text-primary ml-4px">
                      {orderRequest.slotDateTime}
                    </p>
                  </div>
                </div>
              )}
              {type === 'orderUpdatePartner' && (
                <div className="flex justify-end items-center">
                  <img src={oldPartnerIcon} alt="lab" />
                  <p className="text-body-s font-medium text-txtsecondary-shades8 ml-4px line-through">
                    {orderRequest.oldPartnerName}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
        {/* {orderRequest.isDelayed ? (
          <div className="text-center text-body-s text-primary font-semibold py-12px w-full border-t border-solid border-txtsecondary-shades4 tracking-wide">
            Request Callback
          </div>
        ) : (
          <div></div>
        )} */}
      </div>
    );
  } else {
    return <div />;
  }
};

PrescriptionStatusCard.propTypes = {
  onTap: PropTypes.func,
  orderRequest: PropTypes.object.isRequired,
};

export default PrescriptionStatusCard;
